import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'src/@/components/ui/button';
import { useDispatch, useSelector } from 'react-redux';
import useAuth from 'src/hooks/useAuth';
import Iconify from 'src/components/Iconify';
import DrawerNegocioNotas from './components/DrawerNegocioNotas';
import DrawerNegocioTimeline from './components/DrawerNegocioTimeline';
import DrawerNegocioPropostas from './components/DrawerNegocioPropostas';
import DrawerNegocioTarefas from './components/DrawerNegocioTarefas';
import TarefaDialog from 'src/pages/dashboard/Tarefas/TarefaDialog';
import tarefasService from 'src/services/tarefasService';
import { useSnackbar } from 'notistack';
import DrawerContatos from './components/DrawerContatos';
import DrawerCustomTabs from './DrawerCustomTabs';
import {
    getChatInfoByChatId,
    getMensagensWhatsappDb,
    limparChats,
    setChatInfo,
    setLimparChatInfo,
} from 'src/redux/slices/chat';
import { fDateTime, fToNow } from 'src/utils/formatTime';

// ----------------------------------------------------------------------
// CONSTANTES E CONFIGURAÇÕES
// ----------------------------------------------------------------------

const QUALIFICACAO_LABELS = {
    1: 'Sem interesse',
    2: 'Frio',
    3: 'Morno',
    4: 'Esquentando',
    5: 'Quente',
};

// Componente de rating customizado usando Tailwind CSS
const CustomRating = ({ value, onChange, onChangeActive, icon, emptyIcon, max = 5 }) => {
    return (
        <div className="flex gap-1">
            {[...Array(max)].map((_, index) => {
                const ratingValue = index + 1;
                return (
                    <button
                        key={index}
                        type="button"
                        className="p-0.5 border-0 bg-transparent cursor-pointer rounded-full hover:bg-orange-50 dark:hover:bg-orange-500/10 transition-all duration-150 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-orange-200 dark:focus:ring-orange-500/30"
                        onClick={() => onChange(ratingValue)}
                        onMouseEnter={() => onChangeActive && onChangeActive(null, ratingValue)}
                        onMouseLeave={() => onChangeActive && onChangeActive(null, -1)}
                    >
                        <div className="w-4 h-4 flex items-center justify-center">{ratingValue <= value ? icon : emptyIcon}</div>
                    </button>
                );
            })}
        </div>
    );
};

//actions
import v2_actionDetalhesLead from 'src/actions/v2/crm/v2_actionDetalhesLead';
import v2_actionEditarLead from 'src/actions/v2/crm/v2_actionEditarLead';
import { Card } from 'src/@/components/ui/card';
import { ResizablePanelGroup, ResizablePanel, ResizableHandle } from 'src/@/components/ui/resizable';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from 'src/@/components/ui/accordion';
import { Tabs as TabsUI, TabsList as TabsListUI, TabsTrigger as TabsTriggerUI, TabsContent as TabsContentUI } from 'src/@/components/ui/tabs';
import DrawerTransferirLead from './components/DrawerTransferirLead';
import ComponentCloseLead from './components/ComponentCloseLead';
import {
    Dialog,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from 'src/@/components/ui/dialog';
import { Input } from 'src/@/components/ui/input';
import { Label } from 'src/@/components/ui/label';
import { Separator } from 'src/@/components/ui/separator';

// Componente DialogContent customizado sem botão de fechar
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { cn } from 'src/@/lib/utils';

const DialogContent = React.forwardRef(({ className, children, ...props }, ref) => (
    <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay
            className={cn(
                'fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0'
            )}
        />
        <DialogPrimitive.Content
            ref={ref}
            className={cn(
                'fixed left-[50%] top-[50%] z-50 w-full translate-x-[-50%] translate-y-[-50%] border border-gray-200 dark:border-[#383838] bg-white dark:bg-[#1A1D21] shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]',
                className
            )}
            {...props}
        >
            {children}
        </DialogPrimitive.Content>
    </DialogPrimitive.Portal>
));
DialogContent.displayName = 'DialogContent';

import { ChatWindow } from 'src/sections/@chats/chat';
import DrawerTabNegocio from './components/DrawerTabNegocio';
import NegociosHeader from './NegociosHeader';
import DrawerConvertLead from './components/DrawerConvertLead';
import { Badge } from 'src/@/components/ui/badge';
import DrawerDeleteLead from './components/DrawerDeleteLead';
import v2_actionGetLeadScore from 'src/actions/v2/crm/v2_actionGetLeadScore';
import ScoreGauge from './components/ScoreGauge';
import DrawerRealEstate from './components/DrawerRealEstate';
import NegocioInfoRow from './components/NegocioInfoRow';
import PropostaInlineView from 'src/pages/dashboard/Propostas/PropostaInlineView';

export default function ModalNegocio({ configCrm, open, onClose, lead, chat, source, callbackRefreshLeads }) {
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const [leadData, setLeadData] = useState(null);
    const { chatInfo } = useSelector((state) => state.chat);
    const { config } = useSelector((state) => state.global);
    const { user, cliente } = useAuth();
    const [isEditNomeLead, setIsEditNomeLead] = useState(false);
    const [nomeLead, setNomeLead] = useState(null);
    const [sidebarLeft, setSidebarLeft] = useState(false);
    const [openCloseLead, setOpenCloseLead] = useState(false);
    const [openDeleteLead, setOpenDeleteLead] = useState(false);
    const [hover, setHover] = useState(-1);
    const [leadScore, setLeadScore] = useState({ score: 0, credits: 0, debits: 0 });
    // Proposta aberta a partir da seção "Propostas". Enquanto houver uma, o painel
    // esquerdo troca as seções/tabs pela visualização do documento — assim dá para
    // conferir a proposta sem sair do negócio (navegar para o editor descarrega
    // este modal e o caminho de volta é lento).
    const navigate = useNavigate();
    const [propostaAberta, setPropostaAberta] = useState(null);
    const [tarefaDialogOpen, setTarefaDialogOpen] = useState(false);
    const [tarefaSelecionada, setTarefaSelecionada] = useState(null);
    const [tarefaWorkflows, setTarefaWorkflows] = useState([]);
    const [refreshTarefas, setRefreshTarefas] = useState(0);

    function handleCloseChat(open) {
        console.log('ModalNegocio handleCloseChat chamado com:', open);
        // Se open é false, significa que o dialog está sendo fechado
        if (open === false) {
            dispatch(setLimparChatInfo());
            onClose();
        }
    }

    function setar(lead) {
        console.log('ModalNegocio setar chamado com:', lead);
        setLeadData(lead);
        setNomeLead(lead?.nome);
    }

    async function handleLoadChat(value, clienteWhatsapp) {
        if (!value) return;
        dispatch(getMensagensWhatsappDb(clienteWhatsapp?.sessao, value.numero, 1, 10));
        dispatch(getChatInfoByChatId(value._id, value.funil_id, user.id, true));
    }

    useEffect(() => {
        console.log('ModalNegocio useEffect executado com:', { lead, open });
        setar(lead);
        if (lead?._id && open) {
            buscarLeadScore(lead._id);
            // Busca os dados completos e atualizados do lead sempre que o modal abre,
            // em vez de confiar no objeto (possivelmente desatualizado) vindo do cache
            // do Kanban/tabela/busca. Sem isso, reabrir o modal após comentar, editar
            // contato, etc. podia reexibir dados antigos (ex.: comentário recém-criado
            // "sumindo" ao fechar e reabrir), já que nada refaz esse fetch na abertura.
            buscarDetalhesLead(lead._id);
        }
        if (source === 'chat') {
            handleLoadChat(chat, lead?.clienteWhatsapp);
            return;
        }
        handleLoadChat(lead?.whatsapp, lead?.clienteWhatsapp);
        return () => {
            dispatch(setLimparChatInfo());
        };
    }, [lead, open]);

    // Cleanup adicional quando o modal for fechado
    useEffect(() => {
        if (!open) {
            dispatch(setLimparChatInfo());
        }
    }, [open, dispatch]);

    // Trocar de lead ou reabrir o modal sempre volta para as seções: manter uma
    // proposta do lead anterior aberta exibiria o documento errado.
    useEffect(() => {
        setPropostaAberta(null);
        setTarefaDialogOpen(false);
        setTarefaSelecionada(null);
    }, [lead?._id, open]);

    useEffect(() => {
        if (tarefaDialogOpen && user?.clienteId && tarefaWorkflows.length === 0) {
            tarefasService.listarWorkflows(user.clienteId).then(res => {
                setTarefaWorkflows(res.data || []);
            }).catch(() => {});
        }
    }, [tarefaDialogOpen]);

    const handleOpenNovaTarefa = async () => {
        let wfs = tarefaWorkflows;
        if (wfs.length === 0 && user?.clienteId) {
            try {
                const res = await tarefasService.listarWorkflows(user.clienteId);
                wfs = res.data || [];
                setTarefaWorkflows(wfs);
            } catch (error) {
                wfs = [];
            }
        }
        if (wfs.length === 0) {
            enqueueSnackbar('Configure um workflow em Configurações > Tarefas antes de criar.', { variant: 'warning' });
            return;
        }
        setTarefaSelecionada(null);
        setTarefaDialogOpen(true);
    };

    const handleSaveTarefa = async (data) => {
        data.lead_id = leadData?._id;
        if (chatInfo?._id) data.chat_id = chatInfo._id;
        try {
            const response = tarefaSelecionada?._id
                ? await tarefasService.editar(tarefaSelecionada._id, data)
                : await tarefasService.criar(user.clienteId, data);
            if (response.error) {
                enqueueSnackbar(response.message || 'Não foi possível salvar a tarefa', { variant: 'error' });
                return null;
            }
            setRefreshTarefas(prev => prev + 1);
            enqueueSnackbar(tarefaSelecionada ? 'Tarefa atualizada' : 'Tarefa criada', { variant: 'success' });
            return response.data;
        } catch (error) {
            enqueueSnackbar('Não foi possível salvar a tarefa', { variant: 'error' });
            return null;
        }
    };

    async function buscarLeadScore(id) {
        try {
            const result = await v2_actionGetLeadScore(id);
            if (result.data?.data) {
                setLeadScore(result.data.data);
            }
        } catch (error) {
            console.log(error);
        }
    }

    async function buscarDetalhesLead(id) {
        try {
            const result = await v2_actionDetalhesLead(id);
            const data = result.data.data;
            if (data) {
                setLeadData(data);
            }
            console.log('data', data);
        } catch (error) {
            console.log(error);
        }
    }

    async function editarLead(action, value) {
        if (action === 'editar_conversao') {
            let data = {
                action: action,
                scope: {
                    convertido: value ? Number(value) : null,
                },
            };
            await v2_actionEditarLead(lead._id, data, user.id);
            enqueueSnackbar('Negócio alterado com sucesso', {
                variant: 'success',
                autoHideDuration: 3000,
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            });
        }

        if (action === 'editar_contato') {
            let data = {
                action: action,
                scope: {
                    contato_id: value,
                },
            };
            await v2_actionEditarLead(lead._id, data, user.id);
            enqueueSnackbar('Contato alterado com sucesso', {
                variant: 'success',
                autoHideDuration: 3000,
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            });
        }

        if (action === 'editar_nome_lead') {
            let data = {
                action: action,
                scope: {
                    nome: value,
                },
            };
            await v2_actionEditarLead(lead._id, data, user.id);
            enqueueSnackbar('Lead alterado com sucesso', {
                variant: 'success',
                autoHideDuration: 3000,
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            });
        }

        if (action === 'retomar_lead') {
            let data = { action: action, scope: value };
            await v2_actionEditarLead(lead._id, data, user.id);
            enqueueSnackbar('Lead alterado com sucesso', {
                variant: 'success',
                autoHideDuration: 3000,
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            });
        }

        if (action === 'editar_qualificacao') {
            let data = {
                action: action,
                scope: {
                    qualificacao: value,
                },
            };
            await v2_actionEditarLead(lead._id, data, user.id);
            enqueueSnackbar('Qualificação alterada com sucesso', {
                variant: 'success',
                autoHideDuration: 3000,
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            });
        }

        if (action === 'editar_chat_whatsapp') {
            let data = {
                action: action,
                scope: {
                    whatsapp_chat_id: value,
                },
            };
            await v2_actionEditarLead(lead._id, data, user.id);
            enqueueSnackbar('Chat alterado com sucesso', {
                variant: 'success',
                autoHideDuration: 3000,
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            });
        }

        setTimeout(() => {
            buscarDetalhesLead(lead._id);
            callbackRefreshLeads();
        }, 1000);
    }

    async function salvarNomeLead() {
        const nome = nomeLead?.trim();
        // Nome vazio apagaria a identificação do negócio na lista e no kanban.
        if (!nome) return;
        setIsEditNomeLead(false);
        if (nome === leadData?.nome) return;
        // Reflete o nome novo na hora: o refetch dentro de editarLead só acontece
        // 1s depois, e até lá o título seguia mostrando o nome antigo.
        setLeadData((prev) => (prev ? { ...prev, nome } : prev));
        await editarLead('editar_nome_lead', nome);
    }

    function cancelarEdicaoNome() {
        setNomeLead(leadData?.nome ?? null);
        setIsEditNomeLead(false);
    }

    async function handleAlterarQualificacao(value) {
        if (lead?.closed) {
            enqueueSnackbar('Não é possível alterar, reabra o lead antes de continuar', {
                variant: 'error',
                autoHideDuration: 3000,
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            });
            return;
        }
        await editarLead('editar_qualificacao', value);
    }

    const labels = {
        1: 'Venda',
        2: 'Perda',
    };

    return (
        <>
        <Dialog open={open} onOpenChange={handleCloseChat}>
            <DialogContent
                className="flex flex-col min-w-[97%] h-full bg-gradient-to-br from-neutral-100 bg-neutral-100 dark:from-[#1A1D21] dark:via-[#1A1D21] dark:to-[#1A1D21] p-2"
                onInteractOutside={(e) => {
                    // Previne fechamento ao clicar fora do modal
                    e.preventDefault();
                }}
            >
                {!lead ? (
                    <div className="flex items-center justify-center h-full animate-in fade-in zoom-in-95 duration-300">
                        <div className="text-center space-y-3">
                            <Iconify icon="eos-icons:loading" width={32} className="text-[#7C3AED] mx-auto animate-spin" />
                            <p className="text-sm font-medium text-gray-500 dark:text-[#ABABAD] animate-pulse">Carregando dados do lead...</p>
                        </div>
                    </div>
                ) : (
                    <div className="flex flex-col h-full w-full">
                        <div className="flex-shrink-0 animate-in fade-in slide-in-from-top-4 duration-500">
                            <div className="flex items-center justify-between gap-4 mt-1 pb-2">
                                {/* Lado esquerdo - Botão voltar e nome do lead */}
                                <div className="flex items-center gap-3 min-w-0">
                                    <Button variant="secondary" size="icon" onClick={onClose} className="w-8 h-8 shrink-0" title="Voltar para o funil" aria-label="Voltar para o funil">
                                        <Iconify icon="eva:arrow-back-outline" width={18} />
                                    </Button>
                                    {isEditNomeLead ? (
                                        <div className="flex items-center gap-1.5 min-w-0">
                                            <Input
                                                autoFocus
                                                className="h-8 w-[320px] max-w-full text-sm"
                                                value={nomeLead || ''}
                                                onChange={(e) => setNomeLead(e.target.value)}
                                                // Enter salva e Esc cancela: antes só dava para confirmar no
                                                // ícone, e não havia como desistir sem recarregar o modal.
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { e.preventDefault(); salvarNomeLead(); }
                                                    if (e.key === 'Escape') { e.preventDefault(); cancelarEdicaoNome(); }
                                                }}
                                            />
                                            <Button
                                                variant="ghost"
                                                size="icon"
                                                onClick={salvarNomeLead}
                                                disabled={!nomeLead?.trim()}
                                                className="w-8 h-8 shrink-0 text-emerald-600 hover:text-emerald-700 hover:bg-emerald-50 dark:hover:bg-emerald-500/10"
                                                title="Salvar nome"
                                                aria-label="Salvar nome"
                                            >
                                                <Iconify width={18} icon="eva:checkmark-outline" />
                                            </Button>
                                            <Button
                                                variant="ghost"
                                                size="icon"
                                                onClick={cancelarEdicaoNome}
                                                className="w-8 h-8 shrink-0 text-gray-400 hover:text-gray-600"
                                                title="Cancelar"
                                                aria-label="Cancelar edição do nome"
                                            >
                                                <Iconify width={18} icon="eva:close-outline" />
                                            </Button>
                                        </div>
                                    ) : (
                                        // O lápis só aparece no hover/foco: é uma ação secundária e ficava
                                        // competindo com o nome, que é a identidade da tela.
                                        <div className="group flex items-center gap-1 min-w-0">
                                            <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100 truncate" title={leadData?.nome}>
                                                {leadData?.nome}
                                            </h2>
                                            <Button
                                                variant="ghost"
                                                size="icon"
                                                onClick={() => setIsEditNomeLead(true)}
                                                className="w-8 h-8 shrink-0 text-gray-400 opacity-0 transition-opacity group-hover:opacity-100 focus-visible:opacity-100 hover:text-gray-700 dark:hover:text-gray-200"
                                                title="Renomear negócio"
                                                aria-label="Renomear negócio"
                                            >
                                                <Iconify width={16} icon="eva:edit-2-outline" />
                                            </Button>
                                        </div>
                                    )}
                                </div>

                                {/* Lado direito - Informações e ações */}
                                <div className="flex items-center gap-6">
                                    {/* Datas e qualificação */}
                                    <div className="flex items-center gap-4">
                                        {/* <div className="flex flex-col items-center">
                                            <span className="text-[10px] text-gray-500 dark:text-[#ABABAD] font-medium mb-0.5">Score</span>
                                            <ScoreGauge score={leadScore?.score} />
                                        </div> */}

                                        <NegociosHeader
                                            lead={leadData}
                                            user={user}
                                            cliente={cliente}
                                            onVincularChat={async (value) => {
                                                try {
                                                    console.log('Vincular chat ao lead:', value);
                                                    await editarLead('editar_chat_whatsapp', value._id);
                                                    // Carregar as mensagens do chat
                                                    dispatch(getMensagensWhatsappDb(leadData?.clienteWhatsapp?.sessao, value.numero, 1, 10));
                                                    dispatch(setChatInfo(value));
                                                    dispatch(getChatInfoByChatId(value._id, value.funil_id, user.id, true));
                                                } catch (error) {
                                                    console.error('Erro ao vincular chat:', error);
                                                    throw error;
                                                }
                                            }}
                                            onOpenChatWhatsapp={async (value) => {
                                                try {
                                                    console.log('Vincular chat ao lead:', value);
                                                    // Carregar as mensagens do chat
                                                    dispatch(getMensagensWhatsappDb(leadData?.clienteWhatsapp?.sessao, value.numero, 1, 10));
                                                    dispatch(setChatInfo(value));
                                                    dispatch(getChatInfoByChatId(value._id, value.funil_id, user.id, true));
                                                } catch (error) {
                                                    console.error('Erro ao vincular chat:', error);
                                                    throw error;
                                                }
                                            }}
                                            onDesvincularChat={async () => {
                                                try {
                                                    // Desvincular o chat do lead
                                                    await editarLead('editar_chat_whatsapp', null);
                                                    // Limpar o chat atual
                                                    dispatch(setChatInfo(null));
                                                    dispatch(limparChats());
                                                    // Atualizar os dados do lead
                                                    await buscarDetalhesLead(lead._id);
                                                    callbackRefreshLeads();
                                                } catch (error) {
                                                    console.error('Erro ao desvincular chat:', error);
                                                    throw error;
                                                }
                                            }}
                                        />

                                        {/* Qualificação */}
                                        <div className="flex flex-col items-center">
                                            <CustomRating
                                                onChange={handleAlterarQualificacao}
                                                icon={
                                                    <Iconify
                                                        width={18}
                                                        height={18}
                                                        icon="fluent:fire-24-filled"
                                                        className="text-orange-500"
                                                    />
                                                }
                                                emptyIcon={
                                                    <Iconify
                                                        width={18}
                                                        height={18}
                                                        icon="fluent:fire-24-regular"
                                                        className="text-gray-300 dark:text-[#565856]"
                                                    />
                                                }
                                                max={5}
                                                value={leadData?.qualificacao || 0}
                                                onChangeActive={(event, newHover) => setHover(newHover)}
                                            />
                                            <p className="text-xs text-gray-600 dark:text-[#ABABAD] font-medium mt-1">
                                                {QUALIFICACAO_LABELS[hover !== -1 ? hover : leadData?.qualificacao || 0]}
                                            </p>
                                        </div>
                                    </div>

                                    {/* Status de conversão */}
                                    {leadData?.convertido ? (
                                        // O badge inteiro tinha `cursor-pointer` mas só um quadrado de
                                        // 16px removia a conversão — a área clicável não correspondia
                                        // ao que o cursor prometia. Agora o rótulo é estático e o
                                        // "x" é um botão de verdade, com hit area e aria-label.
                                        <Badge
                                            variant="secondary"
                                            className={`h-7 pl-3 pr-1 gap-2 font-medium rounded-md animate-in zoom-in duration-300 ${leadData?.convertido === 1
                                                ? 'bg-green-100 dark:bg-green-500/10 text-green-800 dark:text-green-400 border border-green-300 dark:border-green-500/30'
                                                : 'bg-red-100 dark:bg-red-500/10 text-red-800 dark:text-red-400 border border-red-300 dark:border-red-500/30'
                                                }`}
                                        >
                                            {labels[leadData?.convertido]}
                                            <button
                                                type="button"
                                                title="Remover conversão"
                                                aria-label="Remover conversão"
                                                onClick={async () => {
                                                    if (leadData?.closed) {
                                                        enqueueSnackbar('Não é possível alterar com o lead finalizado', {
                                                            variant: 'error',
                                                            autoHideDuration: 3000,
                                                            anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
                                                        });
                                                        return;
                                                    }
                                                    await editarLead('editar_conversao', {
                                                        convertido: null,
                                                        motivo_perda: null,
                                                        data_conversao: null,
                                                    });
                                                    callbackRefreshLeads();
                                                }}
                                                className={`h-5 w-5 flex justify-center items-center rounded transition-colors ${leadData?.convertido === 1
                                                    ? 'text-green-700 hover:bg-green-500 hover:text-white dark:text-green-400'
                                                    : 'text-red-700 hover:bg-red-500 hover:text-white dark:text-red-400'
                                                    }`}
                                            >
                                                <Iconify icon="eva:close-outline" width={13} />
                                            </button>
                                        </Badge>
                                    ) : (
                                        <DrawerConvertLead
                                            lead={lead}
                                            user={user}
                                            configCrm={configCrm}
                                            onCallback={() => {
                                                buscarDetalhesLead(lead._id);
                                                callbackRefreshLeads();
                                            }}
                                        />
                                    )}

                                    {/* Ações do lead */}
                                    <div className="flex items-center gap-2">
                                        {leadData?.closed ? (
                                            // Mesmo problema do badge de conversão: a área que reabria o
                                            // lead era um retângulo de 12x16px, menor que qualquer alvo
                                            // de toque razoável, e o ícone não dizia o que fazia.
                                            <Badge
                                                variant="secondary"
                                                className="h-7 pl-3 pr-1 gap-2 font-medium rounded-md bg-violet-100 dark:bg-violet-500/10 text-violet-800 dark:text-violet-400 border border-violet-300 dark:border-violet-500/30 animate-in zoom-in duration-300"
                                            >
                                                Lead finalizado
                                                <button
                                                    type="button"
                                                    title="Reabrir lead"
                                                    aria-label="Reabrir lead"
                                                    onClick={async () => {
                                                        try {
                                                            await editarLead('retomar_lead', { closed: false, data_finalizacao: null });
                                                            callbackRefreshLeads();
                                                        } catch (err) {
                                                            console.log(err);
                                                        }
                                                    }}
                                                    className="h-5 w-5 flex justify-center items-center rounded text-violet-700 hover:bg-violet-500 hover:text-white transition-colors dark:text-violet-400"
                                                >
                                                    <Iconify icon="eva:undo-outline" width={13} />
                                                </button>
                                            </Badge>
                                        ) : (
                                            <ComponentCloseLead
                                                lead={leadData}
                                                onOpen={setOpenCloseLead}
                                                open={openCloseLead}
                                                user={user}
                                                onCallback={() => {
                                                    buscarDetalhesLead(lead._id);
                                                    callbackRefreshLeads();
                                                    onClose();
                                                }}
                                                onOpenChange={() => setOpenCloseLead(!openCloseLead)}
                                            />
                                        )}
                                        <DrawerTransferirLead
                                            lead={leadData}
                                            user={user}
                                            onCallback={() => {
                                                buscarDetalhesLead(lead._id);
                                                callbackRefreshLeads();
                                                onClose();
                                            }}
                                        />
                                        <DrawerDeleteLead
                                            lead={leadData}
                                            user={user}
                                            open={openDeleteLead}
                                            onOpenChange={() => setOpenDeleteLead(!openDeleteLead)}
                                            onCallback={() => {
                                                callbackRefreshLeads();
                                                onClose();
                                            }}
                                        />
                                        {/* Separado do grupo acima de propósito: "fechar o modal" estava
                                            encostado em "excluir lead", e as duas eram bolinhas iguais.
                                            Também deixa de ser vermelho — fechar não é destrutivo. */}
                                        <Separator orientation="vertical" className="h-5 mx-1 bg-gray-200 dark:bg-[#383838]" />
                                        <Button variant="secondary" size="icon" onClick={onClose} className="w-8 h-8" title="Fechar" aria-label="Fechar">
                                            <Iconify icon="eva:close-outline" width={18} className="text-gray-600 dark:text-[#ABABAD]" />
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Pipeline Stages - full width */}
                        <div className="animate-in fade-in slide-in-from-bottom-2 duration-500 delay-100 fill-mode-both">
                            <DrawerTabNegocio
                                key={`negocio-${lead?._id}`}
                            lead={leadData}
                            configCrm={configCrm}
                            user={user}
                            cliente={cliente}
                            callbackRefreshLeads={callbackRefreshLeads}
                            callBackRefreshLead={() => buscarDetalhesLead(lead._id)}
                            onOpenChatWhatsapp={(value) => {
                                try {
                                    dispatch(getMensagensWhatsappDb(leadData?.clienteWhatsapp?.sessao, value.numero, 1, 10));
                                    dispatch(setChatInfo(value));
                                    dispatch(getChatInfoByChatId(value._id, value.funil_id, user.id, true));
                                } catch (error) {
                                    console.log(error);
                                }
                            }}
                        />
                        </div>

                        <ResizablePanelGroup direction="horizontal" className="h-full flex-1 gap-2 animate-in fade-in slide-in-from-bottom-4 duration-700 delay-200 fill-mode-both">
                            {/* Painel Esquerdo - Accordions */}
                            <ResizablePanel defaultSize={35} minSize={25} className="min-h-0 overflow-hidden transition-all duration-300">
                                <Card className="h-full flex flex-col min-h-0 overflow-hidden border-gray-200 dark:border-[#383838] transition-all duration-300">
                                    <div className="p-0 flex-1 flex flex-col min-h-0 overflow-hidden">
                                        <div className={`h-full p-4 bg-white dark:bg-[#1A1D21] ${propostaAberta ? 'overflow-hidden' : 'overflow-auto'}`}>
                                            {propostaAberta ? (
                                                <PropostaInlineView
                                                    key={propostaAberta._id}
                                                    propostaId={propostaAberta._id}
                                                    onVoltar={() => setPropostaAberta(null)}
                                                    onEditar={() => navigate(`/dashboard/propostas/${propostaAberta._id}/editar?lead_id=${lead._id}&voltar=negocio`)}
                                                />
                                            ) : (
                                            <LeadSectionsRenderer
                                                layoutConfig={configCrm?.layoutConfig}
                                                hasCustomTabs={configCrm?.customTabs?.length > 0}
                                                hasRealEstate={!!cliente?.config?.modules?.realestate?.status}
                                                sections={{
                                                    negociacao: (
                                                        // Mesmo gap das linhas de dentro do DrawerTabNegocio para as datas
                                                        // e os campos manterem um ritmo vertical único.
                                                        <div className="flex flex-col gap-2">
                                                            <NegocioInfoRow label="Criado em">
                                                                <p className="text-[13px] font-medium text-neutral-700 dark:text-[#D1D2D3]">{lead?.data_criacao ? fDateTime(lead.data_criacao) : '-'}</p>
                                                            </NegocioInfoRow>
                                                            <NegocioInfoRow label="Atualização">
                                                                <p className="text-[13px] font-medium text-neutral-700 dark:text-[#D1D2D3]">{lead?.data_modificacao ? fToNow(lead.data_modificacao) : '-'}</p>
                                                            </NegocioInfoRow>
                                                            <DrawerTabNegocio
                                                                key={`info-${lead?._id}`}
                                                                lead={leadData}
                                                                configCrm={configCrm}
                                                                user={user}
                                                                cliente={cliente}
                                                                callbackRefreshLeads={callbackRefreshLeads}
                                                                callBackRefreshLead={() => buscarDetalhesLead(lead._id)}
                                                                renderMode="info-only"
                                                            />
                                                        </div>
                                                    ),
                                                    contatos: (
                                                        <DrawerContatos
                                                            key={`contatos-${lead?._id}`}
                                                            user={user}
                                                            cliente={cliente}
                                                            lead={leadData}
                                                            onEditarContatoId={(value) => editarLead('editar_contato', value)}
                                                            callbackCreateContact={() => buscarDetalhesLead(lead._id)}
                                                        />
                                                    ),
                                                    atividades: (
                                                        <DrawerNegocioTimeline key={`atividades-${lead?._id}`} data={leadData?.historico} />
                                                    ),
                                                    comentarios: (
                                                        <DrawerNegocioNotas
                                                            key={`comentarios-${lead?._id}`}
                                                            refreshLead={() => buscarDetalhesLead(lead._id)}
                                                            user={user}
                                                            dataLead={leadData}
                                                        />
                                                    ),
                                                    campos_personalizados: configCrm?.customTabs?.length > 0 ? (
                                                        <DrawerCustomTabs
                                                            key={`custom-tabs-${lead?._id}`}
                                                            lead={leadData}
                                                            customTabs={configCrm.customTabs}
                                                            onRefresh={() => buscarDetalhesLead(lead._id)}
                                                        />
                                                    ) : null,
                                                    realestate: cliente?.config?.modules?.realestate?.status ? (
                                                        <DrawerRealEstate
                                                            key={`realestate-${lead?._id}`}
                                                            lead={leadData}
                                                        />
                                                    ) : null,
                                                    propostas: (
                                                        <DrawerNegocioPropostas
                                                            key={`propostas-${lead?._id}`}
                                                            lead={leadData}
                                                            onAbrirProposta={setPropostaAberta}
                                                        />
                                                    ),
                                                    tarefas: (
                                                        <DrawerNegocioTarefas
                                                            key={`tarefas-${lead?._id}`}
                                                            lead={leadData}
                                                            user={user}
                                                            refreshTrigger={refreshTarefas}
                                                            onOpenNovaTarefa={handleOpenNovaTarefa}
                                                            onClickTarefa={(t) => {
                                                                setTarefaSelecionada(t);
                                                                setTarefaDialogOpen(true);
                                                            }}
                                                        />
                                                    ),
                                                }}
                                            />
                                            )}
                                        </div>
                                    </div>
                                </Card>
                            </ResizablePanel>

                            <ResizableHandle withHandle className="!bg-transparent !border-l-1 !border-dashed !border-gray-300 dark:!border-[#383838]" />

                            {/* Painel Direito - Conversa */}
                            <ResizablePanel defaultSize={65} minSize={30} className="min-h-0 overflow-hidden flex flex-col transition-all duration-300">
                                <Card className="h-full flex flex-col min-h-0 overflow-hidden border-gray-200 dark:border-[#383838] transition-all duration-300">
                                    <div className="p-0 flex-1 flex flex-col min-h-0 overflow-hidden">

                                        <div className="flex flex-col flex-1 min-h-0 overflow-hidden h-full animate-in fade-in slide-in-from-right-4 duration-500 delay-300 fill-mode-both" onClick={(e) => e.stopPropagation()}>
                                            {chatInfo ? (
                                                <div className="flex-1 flex flex-col min-h-0 overflow-hidden h-full">
                                                    <ChatWindow
                                                        source="funil.chat"
                                                        sidebarLeft={sidebarLeft}
                                                        changeOpenSidebarLeft={() => {
                                                            setSidebarLeft(!sidebarLeft);
                                                        }}
                                                        config={config}
                                                        chatInfo={chatInfo}
                                                    />
                                                </div>
                                            ) : (
                                                <div className="flex flex-col justify-center items-center h-full bg-neutral-50 dark:bg-[#222529] rounded gap-4 animate-in fade-in zoom-in-95 duration-500 delay-300 fill-mode-both">
                                                    <div className="p-4 rounded-full bg-violet-100 dark:bg-violet-500/10">
                                                        <Iconify
                                                            icon="fluent:chat-empty-24-regular"
                                                            width={48}
                                                            height={48}
                                                            className="text-violet-500 dark:text-violet-400"
                                                        />
                                                    </div>
                                                    <p className="text-sm font-medium text-gray-500 dark:text-[#ABABAD]">
                                                        Nenhuma conversa iniciada ainda com este lead.
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Card>
                            </ResizablePanel>
                        </ResizablePanelGroup>
                    </div>
                )}
            </DialogContent>
        </Dialog>
        <TarefaDialog
            open={tarefaDialogOpen}
            onClose={() => {
                setTarefaDialogOpen(false);
                setTarefaSelecionada(null);
            }}
            onSave={handleSaveTarefa}
            task={tarefaSelecionada}
            workflows={tarefaWorkflows}
            selectedWorkflowId={tarefaSelecionada?.workflow_id?._id || tarefaWorkflows[0]?._id || ''}
            leadId={leadData?._id}
            lead={leadData}
            lockLead
            chatId={chatInfo?._id || null}
        />
        </>
    );
}

// ======================================================================
// LeadSectionsRenderer — renders sections as Accordion or Tabs based on config
// ======================================================================

// Ícone por seção: dá âncora visual para escanear o painel sem ler os rótulos,
// principalmente no modo accordion com todas as seções abertas.
const SECTION_ICONS = {
    negociacao: 'eva:briefcase-outline',
    propostas: 'eva:file-text-outline',
    tarefas: 'eva:checkmark-square-2-outline',
    contatos: 'eva:people-outline',
    atividades: 'eva:activity-outline',
    comentarios: 'eva:message-circle-outline',
    campos_personalizados: 'eva:options-2-outline',
    realestate: 'eva:home-outline',
};

const DEFAULT_ORDEM = [
    { key: "negociacao", label: "Negociação", posicao: 0 },
    { key: "propostas", label: "Propostas", posicao: 1 },
    { key: "tarefas", label: "Tarefas", posicao: 2 },
    { key: "contatos", label: "Contatos", posicao: 3 },
    { key: "atividades", label: "Atividades", posicao: 4 },
    { key: "comentarios", label: "Comentários", posicao: 5 },
    { key: "campos_personalizados", label: "Campos Personalizados", posicao: 6 },
    { key: "realestate", label: "Imóvel", posicao: 7 }
];

function LeadSectionsRenderer({ layoutConfig, hasCustomTabs, hasRealEstate, sections }) {
    const modo = layoutConfig?.modo_visualizacao || 'accordion';
    const ordemBase = layoutConfig?.ordem_secoes?.length > 0
        ? [...layoutConfig.ordem_secoes].sort((a, b) => a.posicao - b.posicao)
        : DEFAULT_ORDEM;

    // Garantir que `realestate` apareça mesmo em layoutConfig salvo antes da
    // adição da seção (registros antigos não têm essa chave em ordem_secoes).
    let ordemConfig = ordemBase.some(s => s.key === 'realestate')
        ? ordemBase
        : [...ordemBase, { key: 'realestate', label: 'Imóvel', posicao: ordemBase.length }];
    // Idem para `propostas`, mas inserida logo após "negociacao" em vez de no fim:
    // é a posição do DEFAULT_ORDEM e a que a tela de configuração já exibe, então
    // jogar no fim faria a ordem divergir para quem salvou o layout antes disso.
    // A partir daqui só a ordem do array importa — `posicao` já foi consumida no sort.
    if (!ordemConfig.some(s => s.key === 'propostas')) {
        const entrada = { key: 'propostas', label: 'Propostas' };
        const idxNegociacao = ordemConfig.findIndex(s => s.key === 'negociacao');
        ordemConfig = idxNegociacao >= 0
            ? [...ordemConfig.slice(0, idxNegociacao + 1), entrada, ...ordemConfig.slice(idxNegociacao + 1)]
            : [entrada, ...ordemConfig];
    }
    if (!ordemConfig.some(s => s.key === 'tarefas')) {
        const entrada = { key: 'tarefas', label: 'Tarefas' };
        const idxPropostas = ordemConfig.findIndex(s => s.key === 'propostas');
        ordemConfig = idxPropostas >= 0
            ? [...ordemConfig.slice(0, idxPropostas + 1), entrada, ...ordemConfig.slice(idxPropostas + 1)]
            : [entrada, ...ordemConfig];
    }

    const secoesFiltradas = ordemConfig.filter(s => {
        if (s.key === 'campos_personalizados' && !hasCustomTabs) return false;
        if (s.key === 'realestate' && !hasRealEstate) return false;
        return sections[s.key] !== undefined && sections[s.key] !== null;
    });

    if (modo === 'tabs') {
        return (
            <TabsUI defaultValue={secoesFiltradas[0]?.key} className="w-full animate-in fade-in slide-in-from-left-4 duration-500 delay-300 fill-mode-both">
                <TabsListUI className="w-full flex gap-0.5 bg-gray-100/80 dark:bg-[#2a2d31] p-0.5 rounded-lg mb-3 overflow-x-auto">
                    {secoesFiltradas.map(secao => (
                        <TabsTriggerUI
                            key={secao.key}
                            value={secao.key}
                            className="flex-1 flex items-center justify-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider px-1.5 py-1.5 whitespace-nowrap
                                text-gray-500 dark:text-neutral-400
                                data-[state=active]:bg-white data-[state=active]:dark:bg-[#383838]
                                data-[state=active]:text-neutral-800 data-[state=active]:dark:text-neutral-100
                                data-[state=active]:shadow-sm rounded-md transition-all"
                        >
                            {SECTION_ICONS[secao.key] && (
                                <Iconify icon={SECTION_ICONS[secao.key]} width={13} className="shrink-0" />
                            )}
                            {secao.label}
                        </TabsTriggerUI>
                    ))}
                </TabsListUI>
                {secoesFiltradas.map(secao => (
                    <TabsContentUI key={secao.key} value={secao.key} className="mt-0">
                        <div className="py-2">
                            {sections[secao.key]}
                        </div>
                    </TabsContentUI>
                ))}
            </TabsUI>
        );
    }

    // Accordion mode (default) — abrir todas as seções por padrão.
    // Cada seção vira um card próprio (em vez de um bloco cinza único): com todas
    // abertas por padrão, é a borda entre cards que diz onde uma seção termina e
    // a outra começa — o divisor interno de lista se perdia no meio do conteúdo.
    return (
        <Accordion type="multiple" defaultValue={secoesFiltradas.map(s => s.key)} className="w-full flex flex-col gap-2 animate-in fade-in slide-in-from-left-4 duration-500 delay-300 fill-mode-both">
            {secoesFiltradas.map((secao) => (
                <AccordionItem
                    key={secao.key}
                    value={secao.key}
                    className="border border-gray-200 dark:border-[#383838] rounded-xl bg-white dark:bg-[#222529] shadow-sm overflow-hidden"
                >
                    <AccordionTrigger className="hover:no-underline py-2.5 px-3 group">
                        <div className="flex items-center gap-2.5 min-w-0">
                            <div className="w-7 h-7 rounded-lg bg-violet-50 dark:bg-violet-500/10 flex items-center justify-center shrink-0 transition-colors group-hover:bg-violet-100 dark:group-hover:bg-violet-500/20">
                                <Iconify icon={SECTION_ICONS[secao.key] || 'eva:folder-outline'} width={15} className="text-violet-600 dark:text-violet-400" />
                            </div>
                            <span className="text-[13px] font-semibold text-neutral-800 dark:text-neutral-100 truncate group-hover:text-[#7C3AED] dark:group-hover:text-violet-400 transition-colors">
                                {secao.label}
                            </span>
                        </div>
                    </AccordionTrigger>
                    <AccordionContent className="px-3 pb-3">
                        <div className="pt-3 border-t border-gray-100 dark:border-[#383838]">
                            {sections[secao.key]}
                        </div>
                    </AccordionContent>
                </AccordionItem>
            ))}
        </Accordion>
    );
}